import * as moment from 'moment';
import { Deserializable } from '../protocols/deserializable';
import { Mentionable } from '../base/mentionable';

export class MemberRetirementStubHistory implements Deserializable {
  public id!: number;
  public retirementStubId!: number;
  public description!: string;
  public comment?: string | null;
  public memberSubmissionId?: number | null;
  public createdById!: number;
  public createdBy!: Mentionable;
  public createdDate!: string;

  // Not from API
  public formattedCreatedDate: string = '';

  public onDeserialize(): void {
    if (this.createdBy) {
      this.createdBy = window?.injector?.Deserialize?.instanceOf(Mentionable, this.createdBy);
    }
    if (this.createdDate) {
      this.formattedCreatedDate = moment(this.createdDate).format('MMMM D, YYYY [at] h:mm A');
    }
  }
}
